function OmnichannelIcon(props) {
  return (
    <svg id='OmnichannelIcon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27.13 27.13' {...props}>
      <g id='Raggruppa_314' data-name='Raggruppa 314' transform='translate(-3 -3)'>
        <path
          id='Tracciato_331'
          data-name='Tracciato 331'
          d='M12.391,29.478h-7.3A2.089,2.089,0,0,1,3,27.391v-7.3A2.089,2.089,0,0,1,5.087,18h7.3a2.089,2.089,0,0,1,2.087,2.087v7.3A2.089,2.089,0,0,1,12.391,29.478Zm-7.3-9.391v7.3h7.3v-7.3Z'
          transform='translate(0 0.652)'
          fill='#fff'
        />
        <path
          id='Tracciato_332'
          data-name='Tracciato 332'
          d='M28.043,3H5.087A2.087,2.087,0,0,0,3,5.087V15.522H5.087V11.348H15.522v4.174h2.087V11.348H28.043v7.3H17.609v2.087H28.043v7.3H17.609V30.13H28.043a2.087,2.087,0,0,0,2.087-2.087V5.087A2.087,2.087,0,0,0,28.043,3Zm0,6.261H5.087V5.087H28.043Z'
          transform='translate(0)'
          fill='#fff'
        />
      </g>
    </svg>
  )
}

export default OmnichannelIcon
